import { z } from 'zod';

/** 엔드포인트 생성/수정 폼 스키마 */
export const endpointFormSchema = z.object({
  code: z
    .string()
    .min(1, '코드를 입력하세요')
    .max(64, '코드는 64자 이하입니다')
    .regex(/^[a-zA-Z0-9\-_]+$/, '코드는 영문/숫자/하이픈/언더스코어만 사용 가능합니다'),
  name: z
    .string()
    .min(1, '표시명을 입력하세요')
    .max(100, '표시명은 100자 이하입니다'),
  protocol: z.enum(['HTTP', 'S3', 'SFTP'], {
    errorMap: () => ({ message: '프로토콜을 선택하세요' }),
  }),
  targetUrl: z.string().max(512, 'URL은 512자 이하입니다').optional().nullable(),
  httpMethod: z.string().max(8, 'HTTP 메서드는 8자 이하입니다').optional().nullable(),
  path: z.string().max(256, '경로는 256자 이하입니다').optional().nullable(),
  description: z.string().max(512, '설명은 512자 이하입니다').optional().nullable(),
  enabled: z.boolean().default(true),
  propagateAuth: z.boolean().default(true),
});

export type EndpointFormValues = z.infer<typeof endpointFormSchema>;

/** 연동 호출 폼 스키마 */
export const invokeFormSchema = z.object({
  pathParams: z.string().optional(),
  queryParams: z.string().optional(),
  body: z.string().optional(),
});

export type InvokeFormValues = z.infer<typeof invokeFormSchema>;

/** 호출 이력 검색 폼 스키마 */
export const callLogSearchSchema = z.object({
  endpointCode: z.string().optional(),
  protocol: z.enum(['', 'HTTP', 'S3', 'SFTP']).optional(),
  result: z.enum(['', 'SUCCESS', 'ERROR']).optional(),
  minStatus: z
    .union([z.number().int().min(100).max(599), z.literal('')])
    .optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  traceId: z.string().max(32).optional(),
});

export type CallLogSearchValues = z.infer<typeof callLogSearchSchema>;

/** TCP echo 콘솔 입력 폼 스키마 (§Δ.2 TcpEchoRequest 1:1) */
export const tcpEchoFormSchema = z.object({
  text: z
    .string()
    .min(1, '전송할 텍스트를 입력하세요')
    .max(4096, '텍스트는 4096자 이하입니다'),
});

export type TcpEchoFormValues = z.infer<typeof tcpEchoFormSchema>;

/** gRPC echo 콘솔 입력 폼 스키마 (§Δ.2 GrpcEchoRequest 1:1) */
export const grpcEchoFormSchema = z.object({
  message: z
    .string()
    .min(1, '전송할 메시지를 입력하세요')
    .max(4096, '메시지는 4096자 이하입니다'),
  stream: z.boolean().default(false),
});

export type GrpcEchoFormValues = z.infer<typeof grpcEchoFormSchema>;
